
/* injects from baggage-loader */
require('./style.scss');

import React from 'react';
import Config from '../../../config/main';
import { t } from '../../../helpers/translator';
import CountDownComponent from "../countDownClock";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { SwarmDataMixin } from '../../../mixins/swarmDataMixin';
import { BetslipPlaceBet } from '../../../actions/betslip';
import { UIMixin } from '../../../mixins/uiMixin';
import PropTypes from 'prop-types';

class ConfirmBet extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            selectedBet: null,
            tid: null,
            lock: false
        };
        this.placeBet = this.placeBet.bind(this);
    }
    componentDidMount () {
        let authDataTid = sessionStorage.getItem('authData') && JSON.parse(sessionStorage.getItem('authData')).tid;
        this.setState({ tid: authDataTid });
    }
    shouldComponentUpdate (nextProps, nextState) {
        let currentBet = nextProps.swarmData.cashdesk[nextState.tid] && nextProps.swarmData.cashdesk[nextState.tid][`bet_confirmation_${nextProps.requestId}`];
        if (currentBet) {
            return true;
        }
        return false;
    }
    componentDidUpdate (prevProps, prevState) {
        let currentBet = this.props.swarmData.cashdesk[prevState.tid] && this.props.swarmData.cashdesk[prevState.tid][`bet_confirmation_${this.props.requestId}`];
        if (currentBet && !this.state.lock) {
            if (currentBet.type === 2) {
                this.setState({ lock: true });
                this.placeBet();
                this.props.closePopup()();
            } else {
                this.props.openPopup("message", {
                    type: "reject",
                    body: t("Your bet was rejected")
                })();
            }
        }
    }
    placeBet () {
        let isConfirmed = true;
        this.props.dispatch(BetslipPlaceBet(this.props.betslip, this.props.terminal.authData.currency, null, this.props.user.profile && this.props.user.profile, 
            null, this.props.terminal, this.props.user.authData, this.props.loyalCard && this.props.loyalCard, this.props.oddsFormat, isConfirmed));
    }

    componentWillUnmount () {
        this.setState({ lock: false });
    }
    render () {
        return (
            <div className='confrimbet-window'>
                <CountDownComponent second={Config.confirmBetCountdownTime} onComplete={this.props.openPopup("message", { type: 'reject', body: t(`Your bet was not confirmed, please try again`) })}/>
                <p>{t(`Your bet is under review`)}</p>
            </div>
        );
    }
}
ConfirmBet.propTypes = {
    betslip: PropTypes.object,
    terminal: PropTypes.object,
    loyalCard: PropTypes.number,
    user: PropTypes.object,
    closePopup: PropTypes.func,
    openPopup: PropTypes.func,
    swarmData: PropTypes.object,
    oddsFormat: PropTypes.string
};
const mapStateToProps = () => {
    return createSelector(
        [
            state => state.cashdesk,
            state => state.user,
            state => (state.swarmData.data && state.swarmData.data.cashdesk),
            state => state.betslip,
            state => state.terminal,
            state => state.uiState.oddsFormat
        ],
        (cashdesk, user, swarmData, betslip, terminal, oddsFormat) => {
            return {
                cashdesk,
                user,
                swarmData,
                betslip,
                terminal,
                oddsFormat
            };
        }
    );
};
export default connect(mapStateToProps)(SwarmDataMixin({Component: UIMixin({
    Component: ConfirmBet,
    ComponentWillMount: function () {
        // this.swarmSubscriptionRequest = getSwarmSubscriptionRequestCashdesk(this.props.authData);
        this.swarmDataKey = 'cashdesk';
        this.keepDataAfterUnsubscribe = true;
    }
})
}));
